import { useEffect, useState } from "react";
import {fetchSelfDashboardData, fetchInterestData} from "PlatForms/SelfLMS/Services/SelfLearnerServices/DashboardService";
const useSelfDashboard = () => {
  const [dashboardData, setDashboardData] = useState(null);
  const [ interest, setInterest] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    const fetchData = async () => {
      try {
  
        const data = await fetchSelfDashboardData();
        console.log("............data",data);
        setDashboardData(data);
      } catch (err) {
        setError(err.message);
      } finally {
        setLoading(false);
      }
    };

    const fetchInterest = async () => {
      try {
      
        const data = await fetchInterestData();
        console.log("..........interest ..data",data);
        setInterest(data);
      } catch (err) {
        setError(err.message);
      } finally {
        setLoading(false);
      }
    };

    fetchData();
    fetchInterest();


  }, []);

  return { dashboardData, interest, loading, error };
};

export default useSelfDashboard;
